export const NotificationEventType = {
    MessageFromAccountantToCustomer: '0',
    MessageFromSupportToCustomer: '1',
    SelfAssessmentAwaitingCustomerApproval: '2',
    SelfAssessmentFiled: '3',
    TaxConsultationSummaryAwaitingApproval: '4',
    CompanyReturnAwaitingCustomerApproval: '5',
    CompanyReturnFiled: '6',
    TaxConsultationToday: '7',
    SelfAssessmentDocumentRequested: '15',
    CompanyReturnStatusReminder: '19',
} as const
